import React from 'react';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { Button } from 'ui-components/components/button/';
import ErrorBoundary from '../../../../components/error-boundary';
import HeaderRow from '../../payment-and-subscription/components/invoice-header-row';
import InvoicesGrid from '../../payment-and-subscription/components/invoice-grid';
import style from './style.module.less';
import messages from '../messages';
import { useSelector } from 'react-redux';
import Global from '../../../../store/global-selectors';
import { HelpCenterService } from '../../../../services/helpcenter-service';

const SubscriptionTab = () => {
  const country = useSelector(Global.selectSellerHomeCountry);
  return (
    <div className={classnames(style['grid-and-footer'], style['no-sidebar'])}>
      <span className={style.disclaimer}>
        <FormattedMessage
          {...messages.invoicesDisclaimer}
          values={{
            supportLink: (chunks) => (
              <Button className={style['button-link']} href={HelpCenterService.getHelpCenterUrl(country)} target='_blank' theme='link'>
                {chunks}
              </Button>
            ),
          }}
        />
      </span>
      <div>
        <ErrorBoundary errorMessageId='invoicesGrid'>
          <HeaderRow />
          <InvoicesGrid shouldShowLeftNavWhenLoading />
        </ErrorBoundary>
      </div>
    </div>
  );
};

export default SubscriptionTab;
